<script setup lang="ts">
import { createStatusUi } from './OrderHistory.vue'

const t2 = useT2({
  'Order ID': 'Užsakymo numeris',
  Status: 'Būsena',
  'Payment status': 'Mokėjimo būsena',
  'Order date': 'Sukurta',
  Total: 'Viso',
})
const getStatusUi = createStatusUi().orderUi()
const getPaymentStatusUi = createStatusUi().payment()

const props = defineProps<{
  order: gen.SellerOrderDocItemFragment | None
  products: gen.SellerOrderProductsListingFragment[] | None
  productsManual?: 'never'
  link: boolean
}>()

const ui = computed(() => {
  const { order, products: products1 } = props
  const products2 = helpers.arr(products1, (p) => {
    const img = getListingImg(p.listing)
    return img ? { id: p.ref.product.id, img } : undefined
  })
  const count = products2.length
  const products = products2.slice(0, count === 4 ? 4 : 3)

  // const missing = 3 - products.length
  // let manual: undefined | gen.SellerOrderDocProductFragment[] = undefined
  // if (productsManual?.length && missing > 0) {
  //   manual = productsManual.length > missing ? productsManual.slice(0, missing) : productsManual
  // }
  const total = order?.productCount ?? count
  return {
    showMore: count < total ? total - products.length : 0,
    total,
    products,
    // manual,
    statusDelivery: getStatusUi.value(order?.uiBox?.statusUi),
    paymentStatus: helpers.isIn(order?.statusPayment, 'Voided', 'Chargeback') ? getPaymentStatusUi.value(order?.statusPayment) : undefined,
  }
})
</script>

<template>
  <UiBox123 :link>
    <template #top>
      <UiLine v-slot="{ emClass }" col :label="t2('Order ID')" value="1" mark><UiId :class="emClass" :value="order?.prettyId" /></UiLine>
      <UiLine col :label="t2('Status')" :value="ui.statusDelivery?.label || ''" :color="ui.statusDelivery?.color" />
      <UiLine v-if="ui.paymentStatus" col :label="t2('Payment status')" :value="ui.paymentStatus.label" :color="ui.paymentStatus.color" />
      <UiLine col :label="t2('Order date')" :value="helpers.uiDate(order?.createdAt)" />
      <UiLine col :label="t2('Total')" :value="order?.prices?._ui?.final?.total?.priceForHumans || ''" price />
    </template>

    <template #left>
      <BuyerAddressUi v-if="order?.uiBox?.address" :address="order?.uiBox?.address" />
    </template>

    <template #right>
      <div :class="$style.images">
        <BaseImage v-for="product in ui.products" :key="product.id" ratio="square" sizes="220px" :lazy="true" :img="product.img" class="_relative _wm200 _br9" />
        <!-- <template v-for="item in ui.manual" :key="item.product.id">
          <BaseImage v-if="item.product.image" ratio="square" sizes="220px" :lazy="true" :src="item.product.image" class="_relative _wm200 _br9" />
          <div v-else-if="item.product.title?.value" class="_label _h100p _br9 _pl1 _pr1 _bg5 _ctr _w100p">{{ item.product.title?.value }}</div>
        </template> -->
        <div v-if="ui.showMore" :class="$style.last"><IconPlus />{{ ui.showMore }}</div>
      </div>
    </template>
  </UiBox123>
</template>

<style module>
.last {
  composes: global(_relative);
  composes: global(_wm200);
  composes: global(_br9);
  composes: global(_ctr);
  composes: global(_fw-xl);
  composes: global(_fs11);

  composes: global(_bg5);
  composes: global(_c2);
}
.images {
  composes: global(_gap1);
  composes: global(m_pl1);
  composes: global(m_pr1);
  composes: global(m_pb2);
  composes: global(_h100p);

  composes: global(_grid);
  grid-template: 1fr / repeat(4, 1fr);
}
</style>
